import { Box, Button, IconButton, Typography, useTheme } from '@mui/material';
import ExoDialog from '../exo/ExoDialog';
import { useState } from 'react';
import { NewEmailIntegration } from '../new/NewEmailIntegration';
import Cookies from 'universal-cookie';
import { tokens } from '../../global/theme/tokens';
import { useTranslation } from 'react-i18next';
import { ProjectAddElementButton } from '../exo/project/ProjectAddElementButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { API_DELETE, DBRequest, useConfig } from '../../api/api';

export const ECSettings = ({ onInboxChange, credentials, onDelete }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();
  const config = useConfig();

  const cookies = new Cookies();
  const userId = cookies.get('userId');

  const [edit, setEdit] = useState(null);
  const [openNew, setOpenNew] = useState(false);

  function handleDelete(cred) {
    DBRequest({
      config,
      path: `email-credentials/${cred.id}`,
      method: API_DELETE(),
      onResponse: () => {
        onDelete(cred);
      },
    });
  }

  return (
    <Box className="flex flex-col gap-2">
      <Typography variant="h4">{t('E-Mail Accounts')}</Typography>
      {credentials?.map((cred) => (
        <Cred
          key={cred.id}
          data={cred}
          onSelect={setEdit}
          onDelete={handleDelete}
        />
      ))}
      <ProjectAddElementButton
        label={t('Add E-Mail')}
        sizePx="40px"
        onClick={() => setOpenNew(true)}
      />
      <ExoDialog
        open={Boolean(edit) || openNew}
        onClose={() => {
          setOpenNew(false);
          setEdit(null);
        }}
        limitWidth
      >
        <NewEmailIntegration
          onChange={onInboxChange}
          startData={edit}
          userid={userId}
          onDelete={onDelete}
          onClose={() => {
            setOpenNew(false);
            setEdit(null);
          }}
        />
      </ExoDialog>
    </Box>
  );
};

const Cred = ({ data, onSelect, onDelete }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const { t } = useTranslation();

  const { label, imapUsername, imapStatus, smtpStatus } = data;

  const imapColor = imapStatus === 1 ? colors.success : colors.error;
  const smtpColor = smtpStatus === 1 ? colors.success : colors.error;
  return (
    <Box
      className="flex items-center"
      sx={{
        '& .delete-btn-wrapper': {
          opacity: 0,
          width: 0,
          overflow: 'hidden',
          transition: 'opacity 0.2s, width 0.2s, margin 0.2s',
        },
        '&:hover .delete-btn-wrapper': {
          opacity: 1,
          width: '48px',
          marginLeft: '8px',
        },
      }}
    >
      <Button
        onClick={() => onSelect(data)}
        sx={{
          flex: 1,
          minWidth: 0,
          alignItems: 'start',
          flexDirection: 'column',
          bgcolor: colors.card,
          border: `1px solid transparent`,
          ':hover': {
            bgcolor: colors.info + '30',
            border: `1px solid ${colors.info}80`,
          },
        }}
      >
        <Box className="flex gap-2 items-center">
          <Typography fontWeight={600}>{label}</Typography>
          <Typography fontWeight={400} className="opacity-50" fontSize={12}>
            {`<${imapUsername}>`}
          </Typography>
        </Box>
        <Typography fontWeight={500} fontSize="12px" sx={{ color: imapColor }}>
          {t('incoming server')}
          <span className="ml-2">
            {imapStatus === 1 ? t('Connected') : t('Connection failed')}
          </span>
        </Typography>
        <Typography fontWeight={500} fontSize="12px" sx={{ color: smtpColor }}>
          {t('outgoing server')}
          <span className="ml-2">
            {smtpStatus === 1 ? t('Connected') : t('Connection failed')}
          </span>
        </Typography>
      </Button>
      <Box className="delete-btn-wrapper flex items-center">
        <IconButton onClick={() => onDelete(data)} sx={{ color: colors.error }}>
          <DeleteIcon />
        </IconButton>
      </Box>
    </Box>
  );
};
